import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateItemStatus, updateStatusAPI } from '../../redux/action';
import AvailabilitySchedule from "./AvailabilitySchedule";
import ToggleSwitch from '../ToggleSwitch';

const ItemStatus = ({ menuId, tab, unit, isAvailable, rawItem }) => {

    const dispatch = useDispatch()
    const hasUpdated = useSelector((state) => state?.admin?.updateStatus[menuId]);
    const availability = hasUpdated ? hasUpdated.isAvailable : isAvailable;

    const [isMarkedAvailable, setIsMarkedAvailable] = useState(availability)
    const dto= [{ menuId: menuId, selectedTabId: tab, isAvailable: !isMarkedAvailable }];
    const handleStatusUpdate = () => {
        setIsMarkedAvailable(!isMarkedAvailable)
        if(menuId !== undefined){
         dispatch(updateStatusAPI(dto));
       // dispatch(updateItemStatus({ menuId: menuId, selectedTabId: tab, isAvailable: !isMarkedAvailable }));
        }            
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", width: "100%", minWidth: 0 }}>
            <ToggleSwitch isOn={isMarkedAvailable} handleToggle={handleStatusUpdate} />
            <AvailabilitySchedule menuId={menuId} name={rawItem?.foodName || rawItem?.name} schedule={rawItem?.availabilitySchedule} />
        </div>
    )
};

export default ItemStatus;